import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CountryState {
  country: string;
}

const initialState: CountryState = {
  country: "senegal", // default
};

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    setCountry: (state, action: PayloadAction<string>) => {
      state.country = action.payload; // Met à jour le pays sélectionné
    },
  },
});

export const { setCountry } = countrySlice.actions;

export const selectCountry = (state: { country: CountryState }) =>
  state.country.country;

export default countrySlice.reducer;
